// cardStyles.js
import { styled } from '@mui/material/styles';

// CloseIconButton component
export const CloseIconButton = styled('div')(({ theme }) => ({
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(2),
}));

// CloseIcon component
export const CloseIcon = styled('span')({
  fontSize: 'medium',
});

// HorizontalDivider component
export const HorizontalDivider = styled('div')({
  borderTop: '2px solid #ccc',
  margin: '10px auto 0px',
  width: '90%',
});
